<template>
  <div class="admin-user-manager-container">
    <el-card class="manager-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">用户管理</span>
        <el-button type="primary" class="add-btn" @click="showAddDialog">
          <i class="el-icon-plus"></i> 添加用户
        </el-button>
      </div>
      
      <div class="search-container">
        <el-input
          placeholder="请输入用户名、昵称、邮箱或电话"
          v-model="searchKeyword"
          class="search-input"
          @keyup.enter.native="fetchUsers"
          clearable
        >
          <el-button slot="append" icon="el-icon-search" @click="fetchUsers" type="primary"></el-button>
        </el-input>
      </div>
      
      <div class="user-table">
        <el-table :data="users" style="width: 100%" stripe highlight-current-row>
          <el-table-column prop="id" label="用户ID" width="100" align="center"></el-table-column>
          <el-table-column prop="username" label="用户名" width="150"></el-table-column>
          <el-table-column prop="nickname" label="昵称" width="150"></el-table-column>
          <el-table-column prop="email" label="邮箱" width="200"></el-table-column>
          <el-table-column prop="phone" label="电话" width="150"></el-table-column>
          <el-table-column prop="roleId" label="角色" width="120" align="center">
            <template slot-scope="scope">
              <el-tag :type="getRoleType(scope.row.roleId)" size="mini">
                {{ getRoleName(scope.row.roleId) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="handleStatusChange(scope.row)"
              ></el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.createTime) }}
            </template>
          </el-table-column>
          <el-table-column prop="updateTime" label="更新时间" width="180" align="center">
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.updateTime) }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300" align="center">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="showEditDialog(scope.row)">编辑</el-button>
              <el-button type="warning" size="mini" @click="showResetPasswordDialog(scope.row)">重置密码</el-button>
              <el-button type="info" size="mini" @click="showUpdateRoleDialog(scope.row)">修改角色</el-button>
              <el-button type="danger" size="mini" @click="deleteUser(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </el-card>
    
    <!-- 添加/编辑用户对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      center
    >
      <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="userForm.username" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input
            v-model="userForm.password"
            type="password"
            placeholder="请输入密码"
          ></el-input>
        </el-form-item>
        <el-form-item label="昵称" prop="nickname">
          <el-input v-model="userForm.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="phone">
          <el-input v-model="userForm.phone" placeholder="请输入电话"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 修改角色对话框 -->
    <el-dialog
      title="修改用户角色"
      :visible.sync="roleDialogVisible"
      width="40%"
      center
    >
      <el-form :model="roleForm" :rules="roleRules" ref="roleForm" label-width="100px">
        <el-form-item label="当前用户">
          <el-input v-model="roleForm.username" readonly placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="当前角色">
          <el-input v-model="roleForm.roleName" readonly placeholder="当前角色"></el-input>
        </el-form-item>
        <el-form-item label="新角色" prop="roleId">
          <el-select v-model="roleForm.roleId" placeholder="请选择角色">
            <el-option
              v-for="role in roles"
              :key="role.id"
              :label="role.name"
              :value="role.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitRoleForm">确定</el-button>
      </div>
    </el-dialog>
    
    <!-- 重置密码对话框 -->
    <el-dialog
      title="重置用户密码"
      :visible.sync="passwordDialogVisible"
      width="40%"
      center
    >
      <el-form :model="passwordForm" :rules="passwordRules" ref="passwordForm" label-width="100px">
        <el-form-item label="用户名">
          <el-input v-model="passwordForm.username" readonly placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            placeholder="请输入新密码"
            show-password
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码" prop="confirmPassword">
          <el-input
            v-model="passwordForm.confirmPassword"
            type="password"
            placeholder="请再次输入新密码"
            show-password
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPasswordForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'AdminUserManager',
  data() {
    return {
      users: [],
      roles: [],
      searchKeyword: '',
      currentPage: 1,
      pageSize: 10,
      total: 0,
      dialogVisible: false,
      roleDialogVisible: false,
      passwordDialogVisible: false,
      dialogTitle: '添加用户',
      userForm: {
        id: null,
        username: '',
        password: '',
        nickname: '',
        email: '',
        phone: '',
        status: 1,
        roleId: 2
      },
      roleForm: {
        userId: null,
        username: '',
        roleId: ''
      },
      passwordForm: {
        userId: null,
        username: '',
        newPassword: '',
        confirmPassword: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        nickname: [
          { required: true, message: '请输入昵称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ]
      },
      roleRules: {
        roleId: [
          { required: true, message: '请选择新角色', trigger: 'change' }
        ]
      },
      passwordRules: {
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          { 
            validator: (rule, value, callback) => {
              if (value !== this.passwordForm.newPassword) {
                callback(new Error('两次输入密码不一致'));
              } else {
                callback();
              }
            }, 
            trigger: 'blur' 
          }
        ]
      }
    }
  },
  created() {
    this.fetchUsers()
    this.fetchRoles()
  },
  methods: {
    fetchUsers() {
      let url = '/user/list'
      if (this.searchKeyword) {
        url = `/user/search?keyword=${encodeURIComponent(this.searchKeyword)}`
      }
      this.$axios.get(url).then(res => {
        this.users = res.data
        this.total = res.data.length
      }).catch(error => {
        this.$message.error('加载用户列表失败')
        console.error('Fetch users error:', error)
      })
    },
    fetchRoles() {
      this.$axios.get('/role/list').then(res => {
        this.roles = res.data
      }).catch(error => {
        this.$message.error('加载角色列表失败')
        console.error('Fetch roles error:', error)
      })
    },
    getRoleName(roleId) {
      const role = this.roles.find(r => r.id === roleId)
      return role ? role.name : '未知角色'
    },
    getRoleType(roleId) {
      return roleId === 1 ? 'danger' : 'primary'
    },
    showAddDialog() {
      this.dialogTitle = '添加用户'
      this.userForm = {
        id: null,
        username: '',
        password: '',
        nickname: '',
        email: '',
        phone: '',
        status: 1,
        roleId: 2
      }
      this.dialogVisible = true
    },
    showEditDialog(user) {
      this.dialogTitle = '编辑用户'
      this.userForm = { ...user }
      // 清空密码字段，避免显示加密密码
      this.userForm.password = ''
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.userForm.validate((valid) => {
        if (valid) {
          if (this.userForm.id) {
            // 更新用户
            this.$axios.put(`/user/update/${this.userForm.id}`, this.userForm)
              .then(res => {
                this.$message.success('更新用户成功')
                this.dialogVisible = false
                this.fetchUsers()
              })
              .catch(error => {
                this.$message.error('更新用户失败')
                console.error('Update user error:', error)
              })
          } else {
            // 添加用户
            this.$axios.post('/user/register', this.userForm)
              .then(res => {
                this.$message.success('添加用户成功')
                this.dialogVisible = false
                this.fetchUsers()
              })
              .catch(error => {
                this.$message.error('添加用户失败')
                console.error('Create user error:', error)
              })
          }
        }
      })
    },
    deleteUser(id) {
      this.$confirm('确定要删除这个用户吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.delete(`/user/delete/${id}`).then(res => {
          this.$message.success('删除用户成功')
          this.fetchUsers()
        }).catch(error => {
          this.$message.error('删除用户失败')
          console.error('Delete user error:', error)
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    handleStatusChange(user) {
      const statusText = user.status == 1 ? '启用' : '禁用';
      this.$confirm(`确定要${statusText}该用户吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.put(`/user/update/${user.id}`, user).then(res => {
          this.$message.success(`用户已${statusText}`)
        }).catch(error => {
          this.$message.error('操作失败')
          // 恢复原状态
          user.status = user.status == 1 ? 0 : 1
          console.error('Update user status error:', error)
        })
      }).catch(() => {
        // 取消操作，恢复原状态
        user.status = user.status == 1 ? 0 : 1
      })
    },
    showUpdateRoleDialog(user) {
      this.roleForm = {
        userId: user.id,
        username: user.username,
        roleId: user.roleId,
        roleName: this.getRoleName(user.roleId)
      }
      this.roleDialogVisible = true
    },
    submitRoleForm() {
      this.$refs.roleForm.validate((valid) => {
        if (valid) {
          this.$axios.put(`/user/update-role/${this.roleForm.userId}`, {}, {
            params: { roleId: this.roleForm.roleId }
          }).then(res => {
            this.$message.success('修改角色成功')
            this.roleDialogVisible = false
            this.fetchUsers()
          }).catch(error => {
            this.$message.error('修改角色失败')
            console.error('Update user role error:', error)
          })
        }
      })
    },
    showResetPasswordDialog(user) {
      this.passwordForm = {
        userId: user.id,
        username: user.username,
        newPassword: '',
        confirmPassword: ''
      }
      this.passwordDialogVisible = true
    },
    submitPasswordForm() {
      this.$refs.passwordForm.validate((valid) => {
        if (valid) {
          this.$axios.put(`/user/reset-password/${this.passwordForm.userId}`, {}, {
            params: { newPassword: this.passwordForm.newPassword }
          }).then(res => {
            this.$message.success('重置密码成功')
            this.passwordDialogVisible = false
          }).catch(error => {
            this.$message.error('重置密码失败')
            console.error('Reset password error:', error)
          })
        }
      })
    },
    handleSizeChange(size) {
      this.pageSize = size
      this.currentPage = 1
      this.fetchUsers()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage
      this.fetchUsers()
    },
    formatDateTime(dateTimeStr) {
      if (!dateTimeStr) return ''
      const date = new Date(dateTimeStr)
      if (isNaN(date.getTime())) return ''
      
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    }
  }
}
</script>

<style scoped>
.admin-user-manager-container {
  padding: 20px 0;
}

.manager-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.add-btn {
  float: right;
}

.search-container {
  margin-bottom: 20px;
}

.search-input {
  width: 300px;
}

.user-table {
  margin-bottom: 20px;
}

.pagination-container {
  text-align: right;
}

@media (max-width: 768px) {
  .search-input {
    width: 100%;
  }
}
</style>
